import { motion } from "framer-motion";

export default function MemberCard({ member }) {
  return (
    <motion.div
      className="bg-dark border border-pinky/40 rounded-2xl p-6 flex flex-col items-center hover:shadow-lg hover:shadow-pinky/30 transition"
      whileHover={{ scale: 1.05 }}
    >
      <img
        src={member.skin}
        alt={member.name}
        className="w-32 mb-4"
      />
      <h3 className="text-pinky text-2xl font-bold">{member.name}</h3>
      <p className="text-gray-300 text-center mt-2">{member.lore}</p>
    </motion.div>
  );
}